/**
 * The base exception used to be able to translate any error
 *
 * @param message String translatable message
 * @param values Object containing the values expected by the exception message in the format {key: value}
 */
class BaseException extends Error {
  #internalValues
  constructor(message, values = {}) {
    super()
    this.message = message
    if (!typeof this.values !== Object) new Error('Invalid values property')
    Object.keys(values).forEach((propertyName) => {
      this[propertyName] = values[propertyName]
    })
    this.#internalValues = values
  }
  get values() {
    return this.#internalValues
  }
}

export default BaseException
